import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail01 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.66669 3.83331L8.47079 8.59618C9.02176 8.98187 9.29725 9.17471 9.59691 9.2494C9.8616 9.31538 10.1384 9.31538 10.4031 9.2494C10.7028 9.17471 10.9783 8.98187 11.5293 8.59618L18.3334 3.83331M5.66669 14.6666H14.3334C15.7335 14.6666 16.4336 14.6666 16.9683 14.3942C17.4387 14.1545 17.8212 13.772 18.0609 13.3016C18.3334 12.7668 18.3334 12.0668 18.3334 10.6666V5.33331C18.3334 3.93318 18.3334 3.23312 18.0609 2.69834C17.8212 2.22793 17.4387 1.84548 16.9683 1.6058C16.4336 1.33331 15.7335 1.33331 14.3334 1.33331H5.66669C4.26656 1.33331 3.56649 1.33331 3.03171 1.6058C2.56131 1.84548 2.17885 2.22793 1.93917 2.69834C1.66669 3.23312 1.66669 3.93318 1.66669 5.33331V10.6666C1.66669 12.0668 1.66669 12.7668 1.93917 13.3016C2.17885 13.772 2.56131 14.1545 3.03171 14.3942C3.56649 14.6666 4.26656 14.6666 5.66669 14.6666Z",
		stroke: "#4A55CF",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMail01;
